import { Api } from '../../Api';
import { ListResult } from '../../interfaces';

export class Orders {
    private static _basePath = '/Order';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${Orders._basePath}`;

        return {
            async get(query: any) {
                const path = '/';

                return await Api.get<ListResult<any>>({
                    path: `${basePath}${path}`,
                    query: {
                        ...query,
                    },
                });
            },

            async getAllOrders(accountId: number) {
                const path = '/GetAllOrders';
                return await Api.get<any>({
                    path: `${basePath}${path}`,
                    query: {
                        accountId: accountId,
                    },
                });
            },

            async putOrder(body: any) {
                const path = '/';
                return await Api.put<string>({
                    path: `${basePath}${path}`,
                    body,
                });
            },
        };
    }
}
